// VIDEO LAZYLOAD
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }


  const productQtyInputs = () =>
    document.querySelectorAll(".productView-quantity .quantity__input");

  // A Yampi desabilita os botoes [name="add"] enquanto consulta o status da loja
  // e o quantity-input do tema copia esse estado (variants.js/checkVariantInventory).
  // Como a Yampi so reabilita o botao, a quantidade continuava disabled: campos
  // disabled nao entram no serialize do form, entao o /cart/add.js ia sem
  // "quantity" e o carrinho sempre recebia 1 item.
  const syncQuantityAvailability = () => {
    const addButton = document.getElementById("product-add-to-cart");
    if (!addButton) return;

    productQtyInputs().forEach((input) => {
      input.disabled = addButton.disabled;
      input
        .closest("quantity-input")
        ?.querySelectorAll(".btn-quantity")
        .forEach((button) => {
          button.disabled = addButton.disabled;
        });
    });
  };

  const addToCartButton = document.getElementById("product-add-to-cart");
  if (addToCartButton) {
    syncQuantityAvailability();
    new MutationObserver(syncQuantityAvailability).observe(addToCartButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }

  const progressiveOfferRadios = document.querySelectorAll(
    'input[name="progressive-offer"]'
  );
  progressiveOfferRadios.forEach((radio) => {
    radio.addEventListener("change", function (e) {
      if (radio.checked) {
        // Replica em todos os seletores de quantidade (principal, oculto e sticky)
        productQtyInputs().forEach((input) => {
          input.value = radio.value;
        });

        const mainQtInput = document.querySelector(
          ".quantity__group--1 .quantity__input"
        );
        // Avisa o tema para recalcular subtotal, preco sticky e regras de estoque
        mainQtInput?.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
});

/**
 * Abertura otimista do carrinho lateral.
 *
 * O tema so abre o drawer depois de TRES requisicoes em serie:
 *   1. POST /cart/add.js            ~584ms
 *   2. GET  /cart.js                ~250ms  (dentro do callback da 1)
 *   3. GET  /cart?view=ajax_side_cart ~322ms, 80KB (dentro do callback da 2)
 * Medido em desktop com conexao boa: ~1,15s ate o drawer aparecer. No 4G a
 * latencia triplica e passa de 3s com um spinner girando na tela.
 *
 * Aqui o drawer abre no clique, com skeleton no lugar do conteudo. As tres
 * requisicoes seguem iguais, mas por tras: quando a etapa 3 responde, o tema
 * faz .html(response) no .previewCart-wrapper e o skeleton e substituido pelo
 * conteudo real sem piscar.
 *
 * Nao altera o fluxo do tema nem o modal de upsell — so antecipa a abertura.
 */
(function () {
  var WRAPPER = "#halo-cart-sidebar .previewCart-wrapper";
  var CLASSE_ABERTO = "cart-sidebar-show";
  var CLASSE_SKELETON = "previewCart--skeleton";
  var LIMITE_MS = 2500; // apos isso, busca o conteudo por conta propria

  var timeoutSeguranca = null;
  var desfazer = null; // preenchido enquanto ha uma abertura otimista no ar

  function drawerConfigurado() {
    // Se a loja estiver configurada para redirecionar ao carrinho ou nao usar
    // o quick cart, abrir o drawer seria errado.
    return (
      window.quick_cart &&
      window.quick_cart.show &&
      window.after_add_to_cart &&
      window.after_add_to_cart.type === "quick_cart"
    );
  }

  function montarSkeleton(linhas) {
    var item =
      '<div class="previewCartSkeleton__item">' +
      '<div class="previewCartSkeleton__thumb"></div>' +
      '<div class="previewCartSkeleton__lines">' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--lg"></span>' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--sm"></span>' +
      "</div></div>";
    return (
      '<div class="previewCartSkeleton" aria-hidden="true">' +
      new Array(linhas + 1).join(item) +
      '<div class="previewCartSkeleton__footer">' +
      '<span class="previewCartSkeleton__line previewCartSkeleton__line--md"></span>' +
      '<div class="previewCartSkeleton__cta"></div>' +
      "</div></div>"
    );
  }

  function limpar() {
    clearTimeout(timeoutSeguranca);
    var wrapper = document.querySelector(WRAPPER);
    if (wrapper) wrapper.classList.remove(CLASSE_SKELETON);
  }

  function abrirComSkeleton() {
    if (!drawerConfigurado()) return;

    var wrapper = document.querySelector(WRAPPER);
    if (!wrapper) return;

    // Carrinho ja aberto e populado: nao mexe.
    if (document.body.classList.contains(CLASSE_ABERTO) && wrapper.children.length) return;

    // Quantas linhas de skeleton: o que ja esta no carrinho + o item entrando.
    var atual = document.querySelector(".cart-count-bubble [data-cart-count]");
    var n = atual ? parseInt((atual.textContent || "").replace(/\D/g, ""), 10) : 0;
    if (isNaN(n)) n = 0;
    wrapper.innerHTML = montarSkeleton(Math.min(n + 1, 3));
    wrapper.classList.add(CLASSE_SKELETON);

    document.body.classList.add(CLASSE_ABERTO);

    // O tema substitui o conteudo do wrapper quando a etapa 3 responde.
    var obs = new MutationObserver(function () {
      if (!wrapper.querySelector(".previewCartSkeleton")) {
        obs.disconnect();
        desfazer = null;
        limpar();
      }
    });
    obs.observe(wrapper, { childList: true });

    /**
     * Fecha a abertura otimista. So faz sentido quando o carrinho continua
     * vazio: se o produto entrou, fechar esconderia justamente o que a cliente
     * quer ver — nesse caso o fallback abaixo busca o conteudo por conta.
     */
    desfazer = function () {
      desfazer = null;
      obs.disconnect();
      clearTimeout(timeoutSeguranca);
      if (wrapper.querySelector(".previewCartSkeleton")) {
        wrapper.innerHTML = "";
        wrapper.classList.remove(CLASSE_SKELETON);
        document.body.classList.remove(CLASSE_ABERTO);
      }
    };

    /**
     * Rede de seguranca: se o skeleton ainda estiver no ar depois do limite, o
     * tema nao preencheu. Antes de desistir, verifica o carrinho de verdade —
     * produto dentro significa que so faltou o HTML, entao busca o mesmo
     * endpoint que o tema usaria. So fecha se o carrinho estiver realmente
     * vazio (add recusado).
     */
    clearTimeout(timeoutSeguranca);
    timeoutSeguranca = setTimeout(function () {
      if (!wrapper.querySelector(".previewCartSkeleton")) return;

      fetch(window.Shopify.routes.root + "cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          if (!carrinho || !carrinho.item_count) throw new Error("carrinho vazio");
          return fetch(window.Shopify.routes.root + "cart?view=ajax_side_cart", {
            credentials: "same-origin",
          }).then(function (r) { return r.text(); });
        })
        .then(function (html) {
          if (!wrapper.querySelector(".previewCartSkeleton")) return; // tema chegou antes
          obs.disconnect();
          desfazer = null;
          wrapper.innerHTML = html;
          wrapper.classList.remove(CLASSE_SKELETON);
        })
        .catch(function () {
          if (desfazer) desfazer();
        });
    }, LIMITE_MS);
  }

  function aoClicar(event) {
    var alvo = event.target.closest(
      '#product-add-to-cart, .product-form__submit, [data-action-add-to-cart], .previewCartCollection a.button-ATC'
    );
    if (!alvo) return;
    if (alvo.disabled || alvo.getAttribute("aria-disabled") === "true") return;
    // "Esgotado"/"Avise-me" nao adicionam nada ao carrinho.
    if (alvo.classList.contains("is-notify-me")) return;
    abrirComSkeleton();
  }

  /**
   * Capture, mas registrado DEPOIS do popup de upsell — e a ordem e o que faz
   * o carrinho abrir na hora certa.
   *
   * O upsell (snippet upsell-imunofem-popup) tambem escuta clique em capture no
   * document e, quando a variante casa com a oferta, chama
   * stopImmediatePropagation() para segurar o add e mostrar a oferta primeiro.
   * Depois que a cliente aceita ou recusa, ele re-dispara o mesmo clique com
   * bypass, e ai o add acontece de verdade.
   *
   * Listeners de capture no mesmo elemento rodam na ordem de registro. Como o
   * custom.js e carregado antes do snippet no theme.liquid, este handler rodava
   * primeiro e abria o drawer no clique interceptado — o carrinho aparecia atras
   * do popup e ficava la, escondido, ate a cliente responder a oferta.
   *
   * Adiando o registro para depois do parse, o popup entra na fila primeiro:
   * no clique interceptado o stopImmediatePropagation nos bloqueia, e no
   * re-clique com bypass o drawer abre normalmente. Resultado: um painel de
   * cada vez, sem replicar aqui nenhuma regra de qual variante tem oferta.
   */
  function registrar() {
    document.addEventListener("click", aoClicar, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", registrar);
  } else {
    registrar();
  }
})();


/* ==========================================================================
 * BRINDE AUTOMATICO · OUTUBRO ROSA
 *   F2 espelho de bolsa: 05 a 15/10/2026, a partir de R$ 220
 *   F3 escova magica:    16 a 22/10/2026, a partir de R$ 299 (regra do Thiago, 15/10)
 *   Black antecipada:    so 31/10/2026, compra a partir de R$ 397 SEM cupom leva
 *                        escova + espelho (Guilherme, 30/10; minimo 397 em 31/10 00h20). Com cupom no
 *                        carrinho ou no permalink, sem brinde. Teto de 50
 *                        escovas: o vigia brinde-3110 adianta o fim da fase.
 * Fase com mais de um brinde usa itens: [...]; as antigas tem variant/handle.
 * Uma fase por vez, escolhida pelo horario (FASES abaixo). O brinde de uma
 * fase que nao e a atual sai de qualquer carrinho.
 *
 * Regra do Thiago, 06/10 (vale pras duas): compra a partir do minimo DEPOIS do
 * desconto (cupom, kit 3x/5x), sem contar o frete, leva 1 brinde gratis.
 *
 * O brinde e um PRODUTO DE R$ 0 (Brinde Espelho de Bolsa - Outubro Rosa,
 * UNLISTED, SKU ESPELHO pro Bling baixar o mesmo SKU, estoque rastreado com
 * policy DENY), nao um desconto: desconto de brinde e classe produto e perde
 * a linha pro kit 3x/5x e pros cupons de link/creator (ver Semana do Cliente,
 * set/2026). Ninguem compra esse produto de proposito, entao QUALQUER linha
 * dele e tratada como brinde, com ou sem a propriedade _brinde.
 *
 * 16/10 (Guilherme): a escova passou a custar R$ 0,01, porque item de R$ 0
 * da erro na emissao da NF. Por isso o brinde pode custar ate PRECO_BRINDE
 * centavos sem ser tratado como cobrado.
 *
 * - Na loja: a cada mudanca de carrinho, compara cart.total_price (ja com
 *   3x/5x e cupom aplicado no carrinho, sem frete) com o minimo e adiciona ou
 *   remove o espelho. Remover vale sempre, inclusive fora da janela.
 *   Cupom digitado so no checkout nao aparece aqui: quem ja tinha o espelho
 *   no carrinho continua com ele.
 * - Nas LPs (pages), que mandam direto pro checkout por permalink
 *   /cart/ID:QTD?discount=cupom, o valor vem da Storefront API (cartCreate
 *   sem token, com as mesmas linhas e o mesmo cupom): e o preco que a cliente
 *   vai ver no checkout. Bateu o minimo, o espelho entra no href.
 * - Esgotou (estoque Shopify 0), para de adicionar.
 * - Fora da janela nao adiciona. Pra testar antes: ?mf_brinde=preview abre a
 *   fase atual; ?mf_brinde=escova abre a F3 antes da hora (fica na aba ate
 *   ?mf_brinde=off).
 * ========================================================================== */
(function () {
  var FASES = [
    { id: 'espelho', variant: 60159103074590, handle: 'brinde-espelho-de-bolsa-outubro-rosa', valor: 'outubro-rosa-espelho',
      min: 22000, start: Date.parse('2026-10-05T03:00:00Z'), end: Date.parse('2026-10-16T03:00:00Z') },
    { id: 'escova', variant: 60327773438238, handle: 'brinde-escova-magica-outubro-rosa', valor: 'outubro-rosa-escova',
      min: 29900, start: Date.parse('2026-10-16T03:00:00Z'), end: Date.parse('2026-10-23T03:00:00Z') },
    { id: 'black3110', valor: 'black-antecipada-3110', semCupom: true,
      itens: [{ variant: 60327773438238, handle: 'brinde-escova-magica-outubro-rosa' },
              { variant: 60159103074590, handle: 'brinde-espelho-de-bolsa-outubro-rosa' }],
      min: 39700, start: Date.parse('2026-10-31T03:00:00Z'), end: Date.parse('2026-11-01T03:00:00Z') /*MF_FIM_BLACK3110*/ }
  ];
  FASES.forEach(function (f) { if (!f.itens) f.itens = [{ variant: f.variant, handle: f.handle }]; });
  function idsDe(f) { return f.itens.map(function (i) { return i.variant; }); }
  function faseForcada() {
    try {
      var q = new URLSearchParams(location.search).get('mf_brinde');
      if (q === 'off') sessionStorage.removeItem('mf_brinde_fase');
      else if (q && FASES.some(function (f) { return f.id === q; })) sessionStorage.setItem('mf_brinde_fase', q);
      return sessionStorage.getItem('mf_brinde_fase');
    } catch (e) { return null; }
  }
  function escolherFase() {
    var forcada = faseForcada(), agora = Date.now(), atual = null, proxima = null;
    FASES.forEach(function (f) {
      if (f.id === forcada) atual = atual || f;
      if (agora >= f.start && agora < f.end && !forcada) atual = f;
      if (agora < f.start && (!proxima || f.start < proxima.start)) proxima = f;
    });
    return atual || proxima || FASES[FASES.length - 1];
  }
  var FASE = escolherFase();
  var CFG = {
    itens: FASE.itens,
    ids: idsDe(FASE),
    semCupom: !!FASE.semCupom,
    prop: '_brinde',
    valor: FASE.valor,
    min: FASE.min,
    start: FASE.start,
    end: FASE.end,
    storefront: '/api/2025-07/graphql.json',
    /* brindes de campanhas anteriores: o NAC de R$ 0 da Semana do Cliente
     * (qualquer linha) e o NAC pago que era zerado por BxGy (so a linha
     * marcada com _brinde). Somem de qualquer carrinho em que aparecerem.
     * O brinde das outras fases do Outubro Rosa tambem. */
    antigoGratis: 59981386842398,
    antigoMarcado: 50535870005534,
    outrasFases: []
  };
  FASES.forEach(function (f) {
    if (f.id !== FASE.id) idsDe(f).forEach(function (id) {
      if (CFG.ids.indexOf(id) === -1 && CFG.outrasFases.indexOf(id) === -1) CFG.outrasFases.push(id);
    });
  });

  /* centavos que o brinde pode custar sem ser tratado como cobrado (R$ 0,01 pela NF) */
  var PRECO_BRINDE = 1;

  function ehBrinde(it) { return CFG.ids.indexOf(it.variant_id) !== -1; }
  /* cupom digitado/link no carrinho (desconto automatico nao conta) */
  function ehCodigo(d) { return !!d && d.type === 'discount_code'; }
  function temCupom(cart) {
    if ((cart.discount_codes || []).some(function (d) { return d.applicable; })) return true;
    if ((cart.cart_level_discount_applications || []).some(ehCodigo)) return true;
    return cart.items.some(function (it) {
      return (it.line_level_discount_allocations || []).some(function (a) { return ehCodigo(a.discount_application); });
    });
  }
  function ehAntigo(it) {
    if (it.variant_id === CFG.antigoGratis) return true;
    if (CFG.outrasFases.indexOf(it.variant_id) !== -1) return true;
    return it.variant_id === CFG.antigoMarcado && !!(it.properties && it.properties[CFG.prop]);
  }
  function valorCompra(cart) {
    var s = cart.total_price || 0;
    cart.items.forEach(function (it) { if (ehBrinde(it) || ehAntigo(it)) s -= it.final_line_price; });
    return s;
  }

  /* Se a Shopify cobrar o espelho ou o total subir ao entrar o brinde, ele sai
   * e o carrinho fica marcado pela ASSINATURA: mexeu no carrinho, tenta de novo. */
  function assinatura(cart) {
    var partes = [];
    cart.items.forEach(function (it) { if (!ehBrinde(it)) partes.push(it.variant_id + 'x' + it.quantity); });
    return partes.sort().join('|');
  }
  function falhas() {
    try { return (sessionStorage.getItem('mf_brinde_pausa3') || '').split(';').filter(Boolean); } catch (e) { return []; }
  }
  function pausado(cart) { return falhas().indexOf(assinatura(cart)) !== -1; }
  function pausar() {
    var lista = falhas();
    Array.prototype.slice.call(arguments).forEach(function (c) {
      var a = assinatura(c);
      if (a && lista.indexOf(a) === -1) lista.push(a);
    });
    try { sessionStorage.setItem('mf_brinde_pausa3', lista.slice(-8).join(';')); } catch (e) {}
  }

  function ativo() {
    try {
      var q = new URLSearchParams(location.search).get('mf_brinde');
      if (q === 'preview' || (q && FASES.some(function (f) { return f.id === q; }))) sessionStorage.setItem('mf_brinde', '1');
      if (q === 'off') sessionStorage.removeItem('mf_brinde');
      if (sessionStorage.getItem('mf_brinde') === '1') return true;
    } catch (e) {}
    var agora = Date.now();
    return agora >= CFG.start && agora < CFG.end;
  }
  var janelaAberta = ativo();

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function post(caminho, corpo) {
    return fetch(root + caminho, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { if (!r.ok) throw new Error(caminho + ' ' + r.status); return r.json(); });
  }

  /* estoque dos brindes: lido uma vez por pagina; devolve os ids que tem estoque */
  var disponivelCache = null;
  function disponivel() {
    if (disponivelCache) return disponivelCache;
    disponivelCache = Promise.all(CFG.itens.map(function (item) {
      return fetch(root + 'products/' + item.handle + '.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = p && (p.variants || []).filter(function (x) { return x.id === item.variant; })[0];
          return v && v.available ? item.variant : null;
        });
    }))
      .then(function (ids) { return ids.filter(Boolean); })
      .catch(function () { disponivelCache = null; return []; });
    return disponivelCache;
  }

  /* ---- carrinho da loja ---- */
  var ocupado = false, pendente = false, nossaChamada = false;

  function garantir() {
    if (ocupado) { pendente = true; return; }
    ocupado = true;
    getCart()
      .then(function (cart) {
        var brindes = [], antigos = {};
        var temAntigo = false;
        cart.items.forEach(function (it) {
          if (ehBrinde(it)) brindes.push(it);
          if (ehAntigo(it)) { antigos[it.key] = 0; temAntigo = true; }
        });
        if (temAntigo) {
          nossaChamada = true;
          return post('cart/update.js', { updates: antigos }).then(function () { return true; });
        }
        var querBrinde = janelaAberta && !pausado(cart) && valorCompra(cart) >= CFG.min && !(CFG.semCupom && temCupom(cart));
        var faltam = CFG.ids.filter(function (id) { return !brindes.some(function (b) { return b.variant_id === id; }); });
        var checar = querBrinde && faltam.length ? disponivel() : Promise.resolve([]);
        return checar.then(function (livres) {
          nossaChamada = true;
          var adicionar = querBrinde ? faltam.filter(function (id) { return livres.indexOf(id) !== -1; }) : [];
          if (adicionar.length) {
            var props = {}; props[CFG.prop] = CFG.valor;
            /* _section_store_cart=1: sem a marca o app de carrinho (Section
             * Store) abre a gaveta em qualquer /cart/add, inclusive nas LPs. */
            return post('cart/add.js?_section_store_cart=1', {
              items: adicionar.map(function (id) { return { id: id, quantity: 1, properties: props }; })
            })
              .then(getCart)
              .then(function (c2) {
                var novas = c2.items.filter(function (it) { return adicionar.indexOf(it.variant_id) !== -1; });
                var cobrado = novas.some(function (it) { return it.final_line_price > PRECO_BRINDE; });
                var subiu = !cobrado && c2.total_price > cart.total_price + PRECO_BRINDE * adicionar.length;
                if (cobrado || subiu) {
                  pausar(cart, c2);
                  if (window.console) console.warn('[brinde espelho] ' + (cobrado ? 'brinde saiu cobrado' : 'total subiu com o brinde') + ', removido');
                  var tira = {};
                  novas.forEach(function (it) { tira[it.key] = 0; });
                  if (novas.length) return post('cart/update.js', { updates: tira }).then(function () { return true; });
                }
                return true;
              }, function (e) {
                /* 422 = esgotou entre a leitura do estoque e o add */
                disponivelCache = Promise.resolve([]);
                throw e;
              });
          }
          if (brindes.length && !querBrinde) {
            var zera = {};
            brindes.forEach(function (it) { zera[it.key] = 0; });
            return post('cart/update.js', { updates: zera }).then(function () { return true; });
          }
          /* uma linha de cada brinde, quantidade 1 */
          var acerta = {}, vistos = {}, precisa = false;
          brindes.forEach(function (it) {
            if (vistos[it.variant_id]) { acerta[it.key] = 0; precisa = true; }
            else { vistos[it.variant_id] = true; if (it.quantity !== 1) { acerta[it.key] = 1; precisa = true; } }
          });
          if (precisa) return post('cart/update.js', { updates: acerta }).then(function () { return true; });
          var caros = brindes.filter(function (it) { return it.final_line_price > PRECO_BRINDE; });
          if (caros.length) {
            pausar(cart);
            var tiraCaros = {};
            caros.forEach(function (it) { tiraCaros[it.key] = 0; });
            return post('cart/update.js', { updates: tiraCaros }).then(function () { return true; });
          }
          return false;
        });
      })
      .then(function (mudou) { nossaChamada = false; if (mudou) return atualizarCarrinho(); })
      .catch(function (e) { nossaChamada = false; if (window.console) console.warn('[brinde espelho]', e); })
      .then(function () {
        ocupado = false;
        if (pendente) { pendente = false; garantir(); }
      });
  }

  function atualizarCarrinho() {
    return getCart().then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      /* app de carrinho (quick cart do tema desligado): atualiza o estado sem abrir a gaveta */
      try {
        if (window.SectionStoreCart && typeof window.SectionStoreCart.refresh === 'function') window.SectionStoreCart.refresh();
      } catch (e) {}
      var gaveta = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      var pagina = document.getElementById('main-cart-items');
      var tarefa = Promise.resolve();
      if (gaveta) {
        tarefa = fetch(root + 'cart?view=ajax_side_cart', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            gaveta.innerHTML = html;
            var barra = document.querySelector('cart-progressbar');
            if (barra && typeof barra.updateProgressBar === 'function') { try { barra.updateProgressBar(cart); } catch (e) {} }
          });
      }
      if (pagina) {
        var sid = pagina.getAttribute('data-id');
        tarefa = tarefa.then(function () {
          return fetch(root + 'cart?section_id=' + sid, { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              [['[data-cart-content] .cart', '[data-cart-content] .cart'],
               ['[data-cart-total] .cart-total-subtotal', '[data-cart-total] .cart-total-subtotal'],
               ['[data-cart-total] .cart-total-grandtotal', '[data-cart-total] .cart-total-grandtotal'],
               ['[data-cart-total] .cart-total-savings', '[data-cart-total] .cart-total-savings']].forEach(function (par) {
                var de = doc.querySelector(par[0]), para = pagina.querySelector(par[1]);
                if (de && para) para.innerHTML = de.innerHTML;
              });
            });
        });
      }
      return tarefa.then(function () {
        try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {}
      });
    });
  }

  var timer = null;
  function agendar(ms) { clearTimeout(timer); timer = setTimeout(garantir, ms || 150); }

  /* gatilhos: evento do tema, e qualquer chamada de carrinho (fetch e XHR) */
  document.addEventListener('cart-update', function () { agendar(120); });

  var reCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, init) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var p = fetchOriginal.apply(this, arguments);
    if (!nossaChamada && reCart.test(url)) p.then(function () { agendar(400); }, function () {});
    return p;
  };
  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (reCart.test(String(url))) {
      this.addEventListener('loadend', function () { agendar(400); });
    }
    return abrirOriginal.apply(this, arguments);
  };

  /* ---- permalinks das LPs (/cart/ID:QTD?discount=cupom -> checkout) ----
   * As LPs trocam o href dos botoes por JS quando a cliente escolhe o kit,
   * entao alem da passada inicial um MutationObserver reavalia todo link
   * cujo href mudou desde a ultima vez que foi tratado. */
  var valoresCache = {}, avisados = {};
  function valorPermalink(itens, cupons) {
    var chave = itens.map(function (i) { return i.id + ':' + i.q; }).join(',') + '|' + cupons.join(',');
    if (valoresCache[chave]) return valoresCache[chave];
    var linhas = itens.map(function (i) { return { merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.q }; });
    valoresCache[chave] = fetchOriginal.call(window, CFG.storefront, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        query: 'mutation($l:[CartLineInput!]!,$d:[String!]){cartCreate(input:{lines:$l,discountCodes:$d}){cart{cost{totalAmount{amount}}}}}',
        variables: { l: linhas, d: cupons }
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cart = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
        if (!cart) throw new Error('storefront sem carrinho');
        return Math.round(parseFloat(cart.cost.totalAmount.amount) * 100);
      })
      /* falhou: segura a chave 10s antes de tentar de novo, a varredura roda a cada 600ms */
      .catch(function (e) { setTimeout(function () { delete valoresCache[chave]; }, 10000); throw e; });
    return valoresCache[chave];
  }
  function reescreverPermalinks() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="/cart/"]')).filter(function (a) {
      var h = a.getAttribute('href') || '';
      return /\/cart\/\d+:\d+/.test(h) && a.getAttribute('data-brinde-ok') !== h;
    });
    if (!links.length) return;
    disponivel().then(function (livres) {
      links.forEach(function (a) {
        var original = a.getAttribute('href');
        var url;
        try { url = new URL(a.href, location.origin); } catch (e) { return; }
        var m = url.pathname.match(/^\/cart\/([\d:,]+)\/?$/);
        if (!m || !livres.length) { a.setAttribute('data-brinde-ok', original); return; }
        var itens = m[1].split(',').map(function (s) { var p = s.split(':'); return { id: +p[0], q: +p[1] || 1 }; });
        if (itens.some(function (i) { return CFG.ids.indexOf(i.id) !== -1; })) { a.setAttribute('data-brinde-ok', original); return; }
        var cupons = (url.searchParams.get('discount') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
        if (CFG.semCupom && cupons.length) { a.setAttribute('data-brinde-ok', original); return; }
        valorPermalink(itens, cupons)
          .then(function (valor) {
            /* a LP pode ter trocado o href enquanto a Storefront respondia */
            if (a.getAttribute('href') !== original) return;
            if (valor >= CFG.min) {
              url.pathname = '/cart/' + m[1] + livres.map(function (id) { return ',' + id + ':1'; }).join('');
              a.href = url.toString();
            }
            a.setAttribute('data-brinde-ok', a.getAttribute('href'));
          })
          .catch(function (e) {
            if (avisados[original]) return;
            avisados[original] = true;
            if (window.console) console.warn('[brinde espelho] permalink', e);
          });
      });
    });
  }
  /* Throttle, nao debounce: LP com carrossel/contador muda o DOM a toda hora e
   * o debounce nunca chegava a rodar (10/10: 6 pedidos de kit + "Complemente
   * seu kit" passaram de R$ 220 sem espelho). A varredura de 600ms cobre href
   * trocado por quem o observer nao ve. */
  var timerLinks = null;
  function agendarLinks() {
    if (timerLinks) return;
    timerLinks = setTimeout(function () { timerLinks = null; reescreverPermalinks(); }, 150);
  }
  function observarLinks() {
    setInterval(function () { if (!document.hidden) reescreverPermalinks(); }, 600);
    if (!window.MutationObserver) return;
    new MutationObserver(agendarLinks)
      .observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
  }

  function iniciar() {
    garantir();
    if (!janelaAberta) return;
    reescreverPermalinks();
    observarLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();


/* ==========================================================================
 * BRINDE AUTOMATICO · KIT 3 MENOVITAL GANHA SERUM FIRMADOR
 *   19/10/2026 18:00 a 26/10/2026 23:59 (Brasilia), regra do Thiago, 19/10
 * Carrinho com 3 ou mais frascos de Menovital (variante 3 Meses, 5 Meses ou
 * 3x a de 1 Mes) leva 1 Brinde Serum Firmador Intimo (produto de R$ 0,
 * UNLISTED, SKU SFIRMADOR, estoque rastreado 300 + DENY), o mesmo que a
 * /pages/lp-semanadomenovital soma nos permalinks dela.
 * Independe do brinde do Outubro Rosa acima: marca propria nos links
 * (data-firmador-ok) e nas falhas (mf_firmador_pausa).
 * - Loja: a cada mudanca de carrinho adiciona/remove o brinde. Remover vale
 *   sempre, inclusive fora da janela.
 * - LPs: permalink /cart/ID:QTD com 3+ frascos ganha ,FIRMADOR:1 no href.
 * - Teste antes da hora: ?mf_firmador=preview (sai com ?mf_firmador=off).
 * ========================================================================== */
(function () {
  var CFG = {
    variant: 60237681525022,
    handle: 'brinde-serum-firmador-semana-menovital',
    prop: '_brinde',
    valor: 'menovital-kit3-firmador',
    /* frascos por variante do Menovital */
    frascos: { 59735292346654: 1, 59735292379422: 3, 59735292412190: 5 },
    min: 3,
    start: Date.parse('2026-10-19T21:00:00Z'),
    end: Date.parse('2026-10-27T03:00:00Z')
  };
  var PRECO_BRINDE = 1;

  function ativo() {
    try {
      var q = new URLSearchParams(location.search).get('mf_firmador');
      if (q === 'preview') sessionStorage.setItem('mf_firmador', '1');
      if (q === 'off') sessionStorage.removeItem('mf_firmador');
      if (sessionStorage.getItem('mf_firmador') === '1') return true;
    } catch (e) {}
    var agora = Date.now();
    return agora >= CFG.start && agora < CFG.end;
  }
  var janelaAberta = ativo();

  function frascosDe(itens) {
    var n = 0;
    itens.forEach(function (i) { n += (CFG.frascos[i.id] || 0) * i.q; });
    return n;
  }
  function ehBrinde(it) { return it.variant_id === CFG.variant; }

  function assinatura(cart) {
    var partes = [];
    cart.items.forEach(function (it) { if (!ehBrinde(it)) partes.push(it.variant_id + 'x' + it.quantity); });
    return partes.sort().join('|');
  }
  function falhas() {
    try { return (sessionStorage.getItem('mf_firmador_pausa') || '').split(';').filter(Boolean); } catch (e) { return []; }
  }
  function pausado(cart) { return falhas().indexOf(assinatura(cart)) !== -1; }
  function pausar(cart) {
    var lista = falhas(), a = assinatura(cart);
    if (a && lista.indexOf(a) === -1) lista.push(a);
    try { sessionStorage.setItem('mf_firmador_pausa', lista.slice(-8).join(';')); } catch (e) {}
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nossaChamada = false;
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function post(caminho, corpo) {
    return fetch(root + caminho, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { if (!r.ok) throw new Error(caminho + ' ' + r.status); return r.json(); });
  }

  var disponivelCache = null;
  function disponivel() {
    if (disponivelCache) return disponivelCache;
    disponivelCache = fetch(root + 'products/' + CFG.handle + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && (p.variants || []).filter(function (x) { return x.id === CFG.variant; })[0];
        return !!(v && v.available);
      })
      .catch(function () { disponivelCache = null; return false; });
    return disponivelCache;
  }

  /* ---- carrinho da loja ---- */
  var ocupado = false, pendente = false;
  function garantir() {
    if (ocupado) { pendente = true; return; }
    ocupado = true;
    getCart()
      .then(function (cart) {
        var brindes = cart.items.filter(ehBrinde);
        var itens = cart.items.map(function (it) { return { id: it.variant_id, q: it.quantity }; });
        var querBrinde = janelaAberta && !pausado(cart) && frascosDe(itens) >= CFG.min;
        var checar = querBrinde && !brindes.length ? disponivel() : Promise.resolve(true);
        return checar.then(function (temEstoque) {
          nossaChamada = true;
          if (querBrinde && !brindes.length && temEstoque) {
            var props = {}; props[CFG.prop] = CFG.valor;
            return post('cart/add.js?_section_store_cart=1', { items: [{ id: CFG.variant, quantity: 1, properties: props }] })
              .then(getCart)
              .then(function (c2) {
                var nova = c2.items.filter(ehBrinde)[0];
                if (nova && nova.final_line_price > PRECO_BRINDE) {
                  pausar(cart);
                  if (window.console) console.warn('[brinde firmador] saiu cobrado, removido');
                  return post('cart/change.js', { id: nova.key, quantity: 0 }).then(function () { return true; });
                }
                return true;
              }, function (e) { disponivelCache = Promise.resolve(false); throw e; });
          }
          if (brindes.length && !querBrinde) {
            var zera = {};
            brindes.forEach(function (it) { zera[it.key] = 0; });
            return post('cart/update.js', { updates: zera }).then(function () { return true; });
          }
          if (brindes.length > 1 || (brindes.length && brindes[0].quantity !== 1)) {
            var acerta = {};
            brindes.forEach(function (it, i) { acerta[it.key] = i === 0 ? 1 : 0; });
            return post('cart/update.js', { updates: acerta }).then(function () { return true; });
          }
          if (brindes.length && brindes[0].final_line_price > PRECO_BRINDE) {
            pausar(cart);
            return post('cart/change.js', { id: brindes[0].key, quantity: 0 }).then(function () { return true; });
          }
          return false;
        });
      })
      .then(function (mudou) { nossaChamada = false; if (mudou) return atualizarCarrinho(); })
      .catch(function (e) { nossaChamada = false; if (window.console) console.warn('[brinde firmador]', e); })
      .then(function () {
        ocupado = false;
        if (pendente) { pendente = false; garantir(); }
      });
  }

  function atualizarCarrinho() {
    return getCart().then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      try {
        if (window.SectionStoreCart && typeof window.SectionStoreCart.refresh === 'function') window.SectionStoreCart.refresh();
      } catch (e) {}
      var pagina = document.getElementById('main-cart-items');
      var tarefa = Promise.resolve();
      if (pagina) {
        var sid = pagina.getAttribute('data-id');
        tarefa = fetch(root + 'cart?section_id=' + sid, { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            ['[data-cart-content] .cart', '[data-cart-total] .cart-total-subtotal',
             '[data-cart-total] .cart-total-grandtotal', '[data-cart-total] .cart-total-savings'].forEach(function (sel) {
              var de = doc.querySelector(sel), para = pagina.querySelector(sel);
              if (de && para) para.innerHTML = de.innerHTML;
            });
          });
      }
      return tarefa.then(function () {
        try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {}
      });
    });
  }

  var timer = null;
  function agendar(ms) { clearTimeout(timer); timer = setTimeout(garantir, ms || 150); }
  document.addEventListener('cart-update', function () { agendar(150); });

  var reCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var fetchAnterior = window.fetch;
  window.fetch = function (entrada) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var p = fetchAnterior.apply(this, arguments);
    if (!nossaChamada && reCart.test(url)) p.then(function () { agendar(450); }, function () {});
    return p;
  };
  var abrirAnterior = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (reCart.test(String(url))) this.addEventListener('loadend', function () { agendar(450); });
    return abrirAnterior.apply(this, arguments);
  };

  /* ---- permalinks das LPs ---- */
  function reescreverPermalinks() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="/cart/"]')).filter(function (a) {
      var h = a.getAttribute('href') || '';
      return /\/cart\/\d+:\d+/.test(h) && a.getAttribute('data-firmador-ok') !== h;
    });
    if (!links.length) return;
    disponivel().then(function (temEstoque) {
      links.forEach(function (a) {
        var original = a.getAttribute('href');
        var url;
        try { url = new URL(a.href, location.origin); } catch (e) { return; }
        var m = url.pathname.match(/^\/cart\/([\d:,]+)\/?$/);
        if (m && temEstoque) {
          var itens = m[1].split(',').map(function (s) { var p = s.split(':'); return { id: +p[0], q: +p[1] || 1 }; });
          var jaTem = itens.some(function (i) { return i.id === CFG.variant; });
          if (!jaTem && frascosDe(itens) >= CFG.min) {
            url.pathname = '/cart/' + m[1] + ',' + CFG.variant + ':1';
            a.href = url.toString();
          }
        }
        a.setAttribute('data-firmador-ok', a.getAttribute('href'));
      });
    });
  }
  var timerLinks = null;
  function agendarLinks() {
    if (timerLinks) return;
    timerLinks = setTimeout(function () { timerLinks = null; reescreverPermalinks(); }, 150);
  }

  function iniciar() {
    garantir();
    if (!janelaAberta) return;
    reescreverPermalinks();
    setInterval(function () { if (!document.hidden) reescreverPermalinks(); }, 600);
    if (window.MutationObserver) {
      new MutationObserver(agendarLinks)
        .observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
